import { defineWave } from '../schema';

/** BLOC D2 — L'ANCRAGE. Le terrain devient un objet.
 *
 *  ── Ce que le Mortier change ──
 *  Il descend, se pose, et ne bouge plus. Ses anneaux transforment sa position
 *  en une zone durablement interdite : pour la première fois du jeu, une partie
 *  du terrain cesse d'appartenir au joueur pendant vingt secondes.
 *
 *  Deux Mortiers posés à des abscisses différentes découpent donc le terrain en
 *  trois régions, et le passage de l'une à l'autre a un coût. C'est la
 *  contrepartie exacte du bloc précédent : D1 apprend à SUIVRE un couloir qui
 *  se déplace, D2 apprend qu'il existe des endroits où l'on ne va plus.
 *
 *  ── Pourquoi les Faucheurs viennent par-dessus ──
 *  Le Mortier seul serait contournable en s'installant loin de lui, ce qui ne
 *  serait pas un choix mais une sortie. Les Faucheurs, dont le tir POURSUIT,
 *  interdisent de camper : le joueur doit se déplacer, mais son espace de
 *  déplacement est désormais amputé. La difficulté naît de la COMBINAISON des
 *  deux natures, pas de la densité de l'une d'elles — c'est le principe qui
 *  tient tout le bestiaire depuis le monde 1.
 *
 *  ⚠️ Les Mortiers sont placés en couloirs 2 et 4, jamais 1 ou 5. Ancrés près
 *  d'un bord, ils condamneraient toute une extrémité du terrain pour la durée du
 *  bloc : le joueur ne serait pas contraint, il serait enfermé. */
export default defineWave({
  id: 'd2-ancrage',
  duration: 30,
  spawns: [
    { at: 0.5, enemy: 'mortier', lane: 2, count: 1, spacing: 0 },
    { at: 3.0, enemy: 'faucheur', lane: 4, count: 1, spacing: 0 },
    { at: 7.5, enemy: 'mite', lane: 3, count: 7, spacing: 0.08 },
    { at: 10.0, enemy: 'mortier', lane: 4, count: 1, spacing: 0 },
    { at: 13.0, enemy: 'faucheur', lane: 2, count: 1, spacing: 0 },
    { at: 16.0, enemy: 'eclat', lane: 1, count: 2, spacing: 0.5 },
    { at: 16.4, enemy: 'eclat', lane: 5, count: 2, spacing: 0.5 },
    { at: 20.0, enemy: 'rodeur', lane: 3, count: 1, spacing: 0 },
    { at: 24.0, enemy: 'mite', lane: 2, count: 8, spacing: 0.07 },
    { at: 26.5, enemy: 'faucheur', lane: 3, count: 2, spacing: 1.2 },
  ],
});
